import React from "react";
import nirmala from "../../images/Nirmala_Mehendale.jpeg";
import lopa from "../../images/lopa.jpg";
import sonal from "../../images/Trustee-Sonal-Singh_resized.jpg";
import sunita from "../../images/Trustee-Sunita-Machado-1.jpg";
import venkat from "../../images/Venkat_500x500.jpg";
import alan from "../../images/alan willims.jpg";

import suprita from "../../images/KU team 2025/Suprita Dutta - Operations Manager.jpeg";
import svetlana from "../../images/cep team/Svetlana Pinto.jpeg";
import bridget from "../../images/cep team/Bridget Viji.jpeg";
import nisa from "../../images/KU team 2026/Nisa Ninan - Website Manager.png";
import noela from "../../images/KU team 2026/Noela Pen - Website Manager.png";
import hardik from "../../images/KU team 2025/Hardik Ved - STEM Mentors for School.jpeg";
import pragyan from "../../images/KU team 2025/Pragyan Ojasvi - STEM Mentors for School.jpeg";
import neilBaretto from "../../images/KU team 2025/Neil Baretto - STEM Mentors for School.jpeg";

import PageLayout from "../ui/PageLayout";
import PageHero from "../ui/PageHero";
import FadeIn from "../ui/FadeIn";

const trustees = [
  {
    name: "Nirmala Peters - Mehendale",
    role: "Founder Trustee and General Secretary",
    img: nirmala,
    linkedin: "https://www.linkedin.com/in/nirmalapetersmehendale/",
  },
  {
    name: "Lopa Vyas",
    role: "Founder Trustee",
    img: lopa,
    linkedin: "https://www.linkedin.com/in/lopavyas/",
  },
  {
    name: "Sonal Singh",
    role: "Trustee",
    img: sonal,
    linkedin: "https://www.linkedin.com/in/sonal-singh-17b5752/",
  },
  {
    name: "Sunita Machado",
    role: "Trustee",
    img: sunita,
    linkedin: "https://www.linkedin.com/in/sunitamachado/",
  },
];

const teamSections = [
  {
    title: "Operations Manager",
    members: [
      { 
        name: "Suprita Dutta", 
        img: suprita, 
        linkedin: "https://www.linkedin.com/in/suprita-bandyopadhyay-36766a66/" 
      }
    ],
  },
  {
    title: "CEP Mentors",
    members: [
      {
        name: "Svetlana Pinto",
        img: svetlana,
        imgPosition: "center top",
        linkedin: "https://www.linkedin.com/in/svetlana-pinto-8320541/",
      },
      {
        name: "Bridget Viji",
        img: bridget,
        linkedin: "https://www.linkedin.com/in/bridget-viji-6aa0a2257/",
      },
    ],
  },
  {
    title: "Website Managers",
    members: [
      { name: "Nisa Ninan", img: nisa, linkedin: "https://www.linkedin.com/in/nisa-ninan/" },
      { name: "Noela Pen", img: noela, linkedin: "https://www.linkedin.com/in/noela-pen-ab091b288" },
    ],
  },
  {
    title: "STEM Mentors for School Project",
    members: [
      { name: "Hrdik Ved", img: hardik, linkedin: "https://www.linkedin.com/in/hrdikved/" },
      { name: "Pragyan Ojasvi", img: pragyan, linkedin: "https://www.linkedin.com/in/pragyan-o-278250330/" },
      { name: "Neil Baretto", img: neilBaretto, linkedin: "https://www.linkedin.com/in/neil-barretto-a4607831a/" },
    ],
  },
];

const TeamCard = ({
  name,
  role,
  img,
  imgPosition,
  linkedin,
}) => (
  <div className="ku-card p-6 text-center group w-full max-w-[320px] mx-auto">
    <div className="relative mx-auto w-44 h-44 mb-5">
      <div className="absolute inset-0 bg-ku-gradient rounded-full blur opacity-30 group-hover:opacity-50 transition-opacity" />

      <img
        src={img}
        alt={name}
        className="relative w-full h-full object-cover rounded-full ring-4 ring-ku-soft shadow-card"
        style={{ objectPosition: imgPosition || "center" }}
      />
    </div>

    <h3 className="font-display font-bold text-ku-royal text-xl">
      {name}
    </h3>

    {role && (
      <p className="font-accent text-sm text-ku-violet mt-1">
        {role}
      </p>
    )}

    {linkedin && (
      <a
        href={linkedin}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 mt-3 px-5 py-2 rounded-full text-sm font-accent font-semibold text-white bg-[#0A66C2] shadow-md hover:shadow-lg hover:bg-[#004182] hover:scale-105 active:scale-95 transition-all duration-200"
      >
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" /></svg>
        LinkedIn
      </a>
    )}
  </div>
);

const OurTeam = () => (
  <PageLayout>
    <PageHero
      title="Our Team"
      eyebrow="The people behind the movement"
      light
    />

    {/* Trustees */}
    <section className="ku-section bg-white">
      <div className="ku-container">
        <FadeIn>
          <h2 className="font-display text-2xl md:text-3xl font-bold text-ku-royal mb-8 text-center">
            KU Trustees
          </h2>
        </FadeIn>

        <div className="flex flex-wrap justify-center gap-6">
          {trustees.map((t, i) => (
            <FadeIn key={t.name} delay={i * 0.08}>
              <TeamCard {...t} />
            </FadeIn>
          ))}
        </div>
      </div>
    </section>

    {/* Mentors */}
    <section className="ku-section bg-ku-gradient-soft">
      <div className="ku-container">
        <FadeIn>
          <h2 className="font-display text-2xl md:text-3xl font-bold text-ku-royal mb-12 text-center">
            KU Mentors
          </h2>
        </FadeIn>

        <div className="flex flex-wrap justify-center gap-8">
          <FadeIn>
            <TeamCard
              name="Venkat N. Krishnan"
              img={venkat}
              linkedin="https://www.linkedin.com/in/venkat-krishnan-n/"
            />
          </FadeIn>

          <FadeIn delay={0.1}>
            <TeamCard
              name="Alan Williams"
              img={alan}
              linkedin="https://www.linkedin.com/in/alanservicebrandglobal/"
            />
          </FadeIn>
        </div>
      </div>
    </section>

    {/* Team */}
    <section className="ku-section bg-white">
      <div className="ku-container">
        <FadeIn>
          <h2 className="font-display text-2xl md:text-3xl font-bold text-ku-royal mb-12 text-center">
            KU Team
          </h2>
        </FadeIn>

        {teamSections.map((section) => (
          <div key={section.title} className="mb-14 last:mb-0">
            <FadeIn>
              <h3 className="font-accent text-lg font-semibold text-ku-violet uppercase tracking-wider mb-6 text-center">
                {section.title}
              </h3>
            </FadeIn>

            <div className="flex flex-wrap justify-center gap-6 max-w-5xl mx-auto">
              {section.members.map((member, mi) => (
                <FadeIn key={member.name} delay={mi * 0.06}>
                  <TeamCard
                    name={member.name}
                    img={member.img}
                    imgPosition={member.imgPosition}
                    linkedin={member.linkedin}
                  />
                </FadeIn>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  </PageLayout>
);

export default OurTeam;